// extracted by mini-css-extract-plugin
module.exports = {"container":"styles-module__container___G2KYn","mediumillustration":"styles-module__mediumillustration___3Cnbt","smallillustration":"styles-module__smallillustration___3n92W"};